import { render, staticRenderFns } from "./searchTag.vue?vue&type=template&id=77e0e3e5&scoped=true&"
import script from "./searchTag.vue?vue&type=script&lang=ts&"
export * from "./searchTag.vue?vue&type=script&lang=ts&"
import style0 from "./searchTag.vue?vue&type=style&index=0&id=77e0e3e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e0e3e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Users\\its_bas_sp_schramwy\\serviceportal\\RUB.Serviceportal\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('77e0e3e5', component.options)
    } else {
      api.reload('77e0e3e5', component.options)
    }
    module.hot.accept("./searchTag.vue?vue&type=template&id=77e0e3e5&scoped=true&", function () {
      api.rerender('77e0e3e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/searchTag.vue"
export default component.exports